import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as Localization from 'expo-localization';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

//import translations
import en from './locales/en.json';
import sp from './locales/sp.json';

const isWeb = typeof window !== 'undefined';

i18n
  .use(HttpBackend) // Loads translations from /public/locales
  .use(LanguageDetector) // Detects browser language
  .use(initReactI18next)
  .init({
    //compatibilityJSON: "v3", //required for react native
    lng: "en", //Localization.getLocales.split('-')[0], // e.g "en-US" -> "en"
    fallbackLng: "en",
    debug: true,
    resources: {
      en: { translation: en },
      sp: { translation: sp },
    },
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;
